import { TaskMetadataReason } from "__graphql__/types";

export const ROLLING_INVENTORY_METADATA_REASONS = [
  TaskMetadataReason.rolling_inventory,
  TaskMetadataReason.rolling_8_weeks,
  TaskMetadataReason.rolling_12_weeks,
];
